import './broadcast';

import nprogress from './nprogress';
Vue.use(nprogress);

import permissions from './permissions';
Vue.use(permissions);

import focus from './focus';
Vue.use(focus);

import modals from './modals';
Vue.use(modals);

import moment from './moment';
Vue.use(moment);

import autosize from './autosize';
Vue.use(autosize);

import routeSync from './routeSync';
Vue.use(routeSync);

import highlight from './highlight';
Vue.use(highlight);

import VueShortkey from 'vue-shortkey';
Vue.use(VueShortkey);
